import { toast } from 'react-toastify';
import ActionResultType from '../interfaces/pieces/ActionResultType';
import type TreeviewActionResult from '../interfaces/pieces/TreeviewActionResult';

const handleCheckAction = async <T>(
	actionOrActions: TreeviewActionResult<T> | TreeviewActionResult<T>[],
	onUpdate: (item: T) => T,
	onChange: (rowData: T, shouldRefreshChildren?: boolean) => void,
	onDelete?: (rowData: T) => void,
	onAdd?: (rowData: T) => void,
	setCurrentAction?: (action: TreeviewActionResult<T> | null) => void,
) => {
	if (!actionOrActions) return;

	const actions = Array.isArray(actionOrActions)
		? actionOrActions
		: [actionOrActions];

	try {
		await Promise.all(
			actions.map(async (action) => {
				switch (action.type) {
					case ActionResultType.UPDATE: {
						const result = await action.result;
						const updatedItem = onUpdate(result);
						onChange(updatedItem, action?.shouldRefreshChildren);
						return;
					}

					case ActionResultType.DELETE: {
						const result = await action.result;
						onDelete?.(result);
						return;
					}

					case ActionResultType.ADD: {
						const result = await action.result;
						onAdd?.(result);
						return;
					}

					default:
						setCurrentAction?.(action);
				}
			}),
		);
	} catch (error) {
		toast.error(error.message);
	}
};

export default handleCheckAction;
